import React from "react"
import {IndexRoute, Redirect, Route, Switch, withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Dashboard from './components/dashboard';
import NavComponent from "./components/layout/nav-component";
import LifeAtInnogy from "./components/life-at-innogy";
import ImportantDocuments from "./components/important-documents";
import Loading from "../../common/js/components/loading";
import SignIn from "../../common/js/auth/components/sign-in";
import Notifications from "../../common/js/notifications/components/notifications";
import Confirmation from './components/auth/confirmation';
import Footer from "./components/layout/footer";
import Forbidden from "./components/forbidden";
import Unauthorized from "./components/unauthorized";
import {addLocaleData, IntlProvider} from "react-intl";
import locale_cs from 'react-intl/locale-data/cs';
import messages_cs from "../locale/cs.json";
import PrivacyPolicy from "../../common/js/components/privacy-policy";
import ForgottenPassword from "../../common/js/auth/components/forgotten-password";
import ForgottenPasswordReset from "../../common/js/auth/components/forgotten-password-reset";

const messages = {
    'cs': messages_cs
};

addLocaleData([...locale_cs]);

class App extends React.Component {

    render() {
        const locale = this.props.lang.locale;

        if (this.props.auth.authenticating || this.props.constants.loading) {
            return (
                <IntlProvider locale={locale} messages={messages[locale]}>
                    <div id='body-container'>
                        <div id='main-container' className='content'>
                            <div className='main-content-menuless container'>
                                <Notifications/>
                                <Loading/>
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </IntlProvider>
            )
        }

        if (!this.props.auth.isAuthenticated) {
            return (
                <IntlProvider locale={locale} messages={messages[locale]}>
                <div id='body-container'>
                    <div id='main-container' className='content'>
                        <Switch>
                            <Route path="/privacy-policy" component={() => <PrivacyPolicy asPage={true}/>}/>
                            <Route path="/confirmation" component={() => <Confirmation/>}/>
                            <Route path="/forgotten-password" exact component={() => <ForgottenPassword/>}/>
                            <Route path="/forgotten-password/reset" component={() => <ForgottenPasswordReset/>}/>
                            <Route path="/forbidden" component={Forbidden}/>
                            <Route path="/sign-in" component={() => <SignIn destination={'inapp'}/>}/>
                            <Route component={() => <Unauthorized destination={'external'}/>}/>
                        </Switch>
                        <Footer/>
                    </div>
                </div>
                </IntlProvider>
            );
        }

        return (
            <IntlProvider locale={locale} messages={messages[locale]}>
                <div id='body-container'>
                    <div id='main-container' className='content'>
                        <NavComponent/>
                        <Switch>
                            <Route path="/privacy-policy" component={() => <div className='main-content'><PrivacyPolicy asPage={true}/></div>}/>
                            <Route path="/life-at-innogy" component={LifeAtInnogy}/>
                            <Route path="/important-documents" component={ImportantDocuments}/>
                            <Route path="/dashboard" component={Dashboard}/>
                            <Route path="/forbidden" component={Forbidden}/>
                            <Redirect to='/dashboard'/>
                        </Switch>
                        <Footer/>
                    </div>
                </div>
            </IntlProvider>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        constants: state.constants,
        lang: state.lang
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(App));
